import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Menu } from "antd";
import { items } from "../../pagesContent/navigationContent";

export default function Navbar() {
  const [current, setCurrent] = useState("/");
  const navigate = useNavigate();
  const location = useLocation();
  const onClick = (e) => {
    if (e.key === "/menu") {
      window.open("/pdfs/menu.pdf", "_blank", "noopener,noreferrer");
    } else {
      navigate(e.key);
    }
  };
  useEffect(() => {
    if (location.pathname) {
      const path = location.pathname;
      setCurrent(path);
      if (path === "/about") {
        setTimeout(() => {
          const aboutSection = document.getElementById("aboutSection");
          if (aboutSection) {
            aboutSection.scrollIntoView({ behavior: "smooth" });
          }
        }, 100);
      } else if (path === "/contact") {
        setTimeout(() => {
          const contactSection = document.getElementById("contactSection");
          if (contactSection) {
            contactSection.scrollIntoView({ behavior: "smooth" });
          }
        }, 100);
      } else {
        window.scrollTo(0, 0);
      }
    }
  }, [location.pathname]);
  return (
    <Menu
      onClick={onClick}
      selectedKeys={[current]}
      mode="horizontal"
      items={items}
    />
    
  );
}
